<p-card [style]="{ 'opacity': 0.9, 'min-height': '100%' }">
  <ng-content></ng-content>
</p-card>
